import { KCommandGroup } from '../cmdkTypes'
import { navCommand } from '../makeCommands'
import { KGroupProcessor } from '../useCommandStore'

/**
 * For any group with a path (nav commands going to `path` with state),
 * just add the basic "go there" command automatically.
 */
export const addViewPath: KGroupProcessor = ({ name, path, commands }: KCommandGroup) =>
  path && commands.every((cmd) => cmd.label !== `View ${name}`)
    ? {
        name,
        path,
        commands: [
          navCommand({ label: `View ${name}`, iconName: 'external-link', path }),
          ...commands,
        ],
      }
    : { name, path, commands }
